import { z } from 'zod';
import {
  dbSigningAgentUpdateSchema,
  dbSigningAgentSchema,
} from './db-signing-agent';

export const updateSigningAgentRequestParamsSchema = z.object({
  id: z.string().uuid(),
});

export type UpdateSigningAgentRequestParams = z.infer<
  typeof updateSigningAgentRequestParamsSchema
>;

export const updateSigningAgentRequestBodySchema = dbSigningAgentUpdateSchema;

export type UpdateSigningAgentRequestBody = z.infer<
  typeof updateSigningAgentRequestBodySchema
>;

export const updateSigningAgentSuccessResponseSchema = z.object({
  data: dbSigningAgentSchema,
});

export type UpdateSigningAgentSuccessResponse = z.infer<
  typeof updateSigningAgentSuccessResponseSchema
>;

export const updateSigningAgentErrorResponseSchema = z.object({
  errors: z.array(
    z.object({
      message: z.string(),
      key: z.string().optional(),
      source: z.string().optional(),
    })
  ),
});

export type UpdateSigningAgentErrorResponse = z.infer<
  typeof updateSigningAgentErrorResponseSchema
>;

export const updateSigningAgentResponseSchema =
  updateSigningAgentSuccessResponseSchema.or(
    updateSigningAgentErrorResponseSchema
  );

export type UpdateSigningAgentResponse = z.infer<
  typeof updateSigningAgentResponseSchema
>;
